import axios from "axios";
import SnackbarService from "../../../app/components/theme/Snackbar/service";
import BlockUIService from "../../../app/components/theme/BlockUI/service";

const { REACT_APP_API_LOCATION } = process.env;

const BASE_URL = `${REACT_APP_API_LOCATION}/catalogs/device-models/curation`;

const api = {
  load: async (params: any) => {
    BlockUIService.show();
    try {
      const response = await axios.get(`${BASE_URL}/duplicate-groups`, { params });
      return response.data;
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "Ha ocurrido un problema al cargar los grupos", "error");
      return { items: [], pagination: { total: 0, pages: 1, pageNumber: 1 } };
    } finally {
      BlockUIService.hide();
    }
  },
  getGroup: async (groupId: string) => {
    BlockUIService.show();
    try {
      const response = await axios.get(`${BASE_URL}/duplicate-groups/${groupId}`);
      return response.data;
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "No se pudo cargar el detalle del grupo", "error");
      throw e;
    } finally {
      BlockUIService.hide();
    }
  },
  merge: async (groupId: string, officialDeviceModelId: string) => {
    BlockUIService.show();
    try {
      const response = await axios.post(
        `${BASE_URL}/duplicate-groups/${groupId}/merge`,
        { officialDeviceModelId, confirmMerge: true },
      );
      await SnackbarService.show("Fusión ejecutada correctamente", "success");
      return response.data;
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "No se pudo ejecutar la fusión", "error");
      throw e;
    } finally {
      BlockUIService.hide();
    }
  },
  mergeMultiple: async (groupIds: string[], officialDeviceModelId: string) => {
    BlockUIService.show();
    try {
      const response = await axios.post(`${BASE_URL}/duplicate-groups/merge-multiple`, {
        groupIds, officialDeviceModelId, confirmMerge: true,
      });
      await SnackbarService.show("Fusión de grupos ejecutada correctamente", "success");
      return response.data;
    } catch (e: any) {
      const message = e?.response?.data?.error?.message;
      await SnackbarService.show(message || "No se pudo ejecutar la fusión de grupos", "error");
      throw e;
    } finally { BlockUIService.hide(); }
  },
};

export default api;
